<template>
  <div>
  <el-form
      ref="form"
      :model="form">
    <div class="gj-picker">
      <div class="gj-picker__editor">
        <el-tabs :value="'second'">
          <el-tab-pane
              v-if="false"
              label="搜索"
              name="first">
            <div class="gj-picker__editor--search-input">
              <gj-input
                  v-model="keyword"
                  placeholder="按商品标题、ASIN、MSKU编码搜索"
                  size="medium"
                  underline
                  width="100%">
                <template #append>
                  <gj-button
                      icon="el-icon-search  "
                      @click="$gjNoticeQuery"
                  ></gj-button>
                </template>
              </gj-input>
            </div>
            <div class="gj-picker__editor--body">
              <gj-table
                  :index="false"
                  :show-pagination="false"
                  :adapt-height="false"
                  :height="318"
                  :data="tableData"
                  :columns="columns0"
                  :loading="loading"
                  class="suggest-table"
                  :pagination="pagination"
                  :pagination-option="{small: true, background: false, layout: 'total, prev, pager, next, sizes'}"
                  @page-change="$gjNoticeQuery">
                <template v-slot:header:op>
                  <gj-button
                      type="text"
                      @click="addAllItem()"
                  >添加全部</gj-button>
                </template>
                <template v-slot:listingTitle="{ row }">
                  <div style="margin: 4px 0;">
                    <gj-tooltip
                        :text-line="1"
                        :content="row.listingTitle">
                      {{row.listingTitle | defaultShow}}
                    </gj-tooltip>
                    <el-row
                        v-if="false"
                        type="flex"
                        align="middle"
                        v-gutter="8">
                      <el-rate
                          :value="row.star"
                          disabled
                          style="display: inline;"
                          text-color="#ff9900">
                      </el-rate>
                      <span>({{row.star}})</span>
                      <el-divider direction="vertical"></el-divider>
                      <span style="color: #CC0000">{{row.price | defaultShow(adStore.SP.currencySymbol)}}</span>
                    </el-row>
                    <el-row>
                      <el-col :span="10">
                        <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
                      </el-col>
                      <el-col :span="14">
                        <span style="font-weight: 600;">MSKU：</span>{{row.msku | defaultShow}}
                      </el-col>
                    </el-row>
                  </div>
                </template>
                <template v-slot:op="{ index, row }">
                  <gj-button
                      type="text"
                      :disabled="row.btnDisabled"
                      @click="addItem(index, row)"
                  >添加</gj-button>
                </template>
              </gj-table>
            </div>
          </el-tab-pane>
          <el-tab-pane label="输入" name="second">
            <AdBatchInput :items="form.items" v-model="inputText" :afterFn="afterFn"></AdBatchInput>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="gj-picker__table">
        <div class="gj-picker__table--title">
          已添加 {{form.items.length}} 个{{title}}<span class="gj-picker__table--tip">（最多可添加1000个，会过滤重复的{{title}}）</span>
        </div>
        <gj-table
            :index="false"
            :show-pagination="false"
            :adapt-height="false"
            :height="358"
            :data="form.items"
            :columns="columns"
            stripe>
          <template v-slot:header:op>
            <gj-button
                type="text"
                @click="deleteAllItem()"
            >全部移除</gj-button>
          </template>
          <template v-slot:listingTitle="{ row }">
            <template v-if="row.type && row.type === 'asin'">
              <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
            </template>
            <div v-else style="margin: 4px 0;">
              <gj-tooltip
                  :text-line="1"
                  :content="row.listingTitle">
                {{row.listingTitle | defaultShow}}
              </gj-tooltip>
              <el-row
                  v-if="false"
                  type="flex"
                  align="middle"
                  v-gutter="8">
                <el-rate
                    :value="row.star"
                    disabled
                    style="display: inline;"
                    text-color="#ff9900">
                </el-rate>
                <span>({{row.star}})</span>
                <el-divider direction="vertical"></el-divider>
                <span style="color: #CC0000">{{row.price | defaultShow(adStore.SP.currencySymbol)}}</span>
              </el-row>
              <el-row>
                <el-col :span="10">
                  <span style="font-weight: 600;">ASIN：</span>{{row.asin | defaultShow}}
                </el-col>
                <el-col :span="14">
                  <span style="font-weight: 600;">MSKU：</span>{{row.msku | defaultShow}}
                </el-col>
              </el-row>
            </div>
          </template>
          <template v-slot:op="{ index, row }">
            <gj-button
                type="text"
                @click="deleteItem(index, row)"
            >移除</gj-button>
          </template>
        </gj-table>
      </div>
    </div>
  </el-form>
  <div class="gj-picker-solid"></div>
  </div>
</template>

<script>
  import {formMixin, isMeaningfulMixin, queryMixin} from "../../../../../../../../minxins";
  import {isMeaningful, unique} from "../../../../../../../../utils/common";
  import {adStoreMixin} from "../../../../../common/mixin";
  import {getListingPage} from "../../../../../../../../api/ad";
  import AdBatchInput from '@/views/modules/ad/common/components/ad-batch-input.vue'

  export default {
    name: "app-auto-neg-target-picker",
    mixins: [isMeaningfulMixin, formMixin,
      adStoreMixin, queryMixin],
    components: { AdBatchInput },
    props: {
      marketId: {
        required: true
      },
      title: {
        required: true,
      }
    },
    created() {
    },
    data() {
      return {
        tableData: [],
        keyword: null,
        inputText: null,
        columns0: [
          {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:listingTitle', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80px'},
        ],
        columns: [
          // {id: 'picture', header: '图片', field: 'picture:imageUrl', width: '60px'},
          {id: 'listingTitle', header: '商品信息',field: 'slot:listingTitle', minWidth: '180px'},
          {id: 'op', header: 'slot:op',field: 'slot:op', width: '80px'},
        ],
        errorKeyword: false,
        keywordStyle: {height: '292px'}
      }
    },
    watch: {
      inputText(val) {
        this.errorKeyword = !/^[^!#%<>@*$]*$/.test(val);
      }
    },
    methods: {
      async afterFn(val) {
        const items = val.success.map(e => ({
          id: e,
          asin: e,
          type: 'asin',
        }))
        this.form.items = unique([].concat(this.form.items).concat(items));
        return true
      },
      _$gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            marketId: this.marketId,
            fuzzyParam: this.keyword,
            fuzzyParamType: 'asin,msku',
            status: 'Active'
          },
          ...this.queryPagination,
          ...this.querySort
        };
        // 查询
        this.loading = true;
        getListingPage(params)
          .then((data) => {
            if (isMeaningful(data) && isMeaningful(data.records)) {
              this.tableData = data.records.map(e => ({
                ...e,
                listingTitle: e.title
              }));
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
            this.refreshBtnDisable();
          })
          .complete(() => this.loading = false);
      },
      addAllItem() {
        this.form.items = unique([].concat(this.form.items).concat(this.tableData), 'msku');
        this.refreshBtnDisable();
      },
      addItem(index, row) {
        this.form.items = unique([].concat(this.form.items).concat([row]), 'msku');
        this.refreshBtnDisable();
      },
      refreshBtnDisable() {
        this.tableData.forEach(e1 => {
          if (this.form.items.some(e2 => e1.msku === e2.msku)) {
            this.$set(e1, 'btnDisabled', true);
          } else {
            this.$set(e1, 'btnDisabled', false);
          }
        });
      },
      deleteAllItem() {
        this.form.items = [];
        this.refreshBtnDisable();
      },
      deleteItem(index) {
        this.form.items.splice(index, 1);
        this.refreshBtnDisable();
      },
      formValidate() {
        return new Promise((resolve, reject) => {
          if (this.form.items.length <= 0) {
            this.$gjMessage.closeAll();
            this.$gjMessage.error('请添加否定商品');
            reject();
          } else {
            this.$refs.form.validate(valid => {
              valid ? resolve() : reject()
            });
          } 
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "picker";
  
  .gj-picker__editor {
    padding: 0;
  }
  .gj-picker__editor,
  .gj-picker__table {
    width: 50%;
  }
  
  .default-bid {
    margin-bottom: 0;
    position: absolute;
    top: 0;
    left: 280px;
  }
  
  /deep/ .el-tabs__header {
    margin-bottom: 0 !important;
  }
  
  /*/deep/ .el-tabs__content {*/
  /*  padding: 0 !important;*/
  /*}*/
  
  /deep/ .gj-picker__editor--search-input .el-input__inner {
    height: 46px;
    line-height: 46px;
    font-size: 13px;
  }
  
  /deep/ .el-input-group__append {
    border-radius: 0;
    border-right: 0;
    padding: 0 14px;
  }

  /deep/ .el-pagination .btn-prev {
    padding-right: 3px;
  }
  /deep/ .el-pagination .btn-next {
    padding-left: 3px;
  }
  /deep/ .el-pagination__total {
    margin-right: 2px;
  }
  /deep/ .footer__pagination {
    margin-right: 0;
  }
  /deep/ .el-pagination {
    padding-right: 0;
  }
  /deep/ .el-pagination .el-select .el-input {
    width: 90px;
  }

</style>

